export default "__VITE_ASSET__CwLziykf__"